export const ACCORDION_TITLE_BAR_HEIGHT = '48px';
export const ACCORDION_FOOTER_HEIGHT = '67px';
export const ACCORDION_PADDING_TOP = '40px';
export const ACCORDION_HEIGHT_CALCULATED = `calc(100vh - ${ACCORDION_TITLE_BAR_HEIGHT} - ${ACCORDION_FOOTER_HEIGHT} - ${ACCORDION_PADDING_TOP})`;
export const ACCORDION_HEIGHT_CALCULATED_FULLSCREEN = `calc(100vh - ${ACCORDION_TITLE_BAR_HEIGHT} - ${ACCORDION_FOOTER_HEIGHT})`;

export const SIDE_NAV_WIDTH = '244px';

export const SIDE_NAV_WIDTH_SMALL = '80px';

export const SIDE_NAV_SMALL_WIDTH_GLOBALSEARCH = '110px';

export const HEADER_HEIGHT = '34.5px';

export const SELECT_PLACEHOLDER = 'Select one option...';

export const MAX_NAME_LENGTH = 60;

export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const PAGE_TOP_PADDING = '32px'; // TODO remove by finding a way to define once

export const EDIT_NOTE_ACCORDION_WIDTH_LARGE = '1000px';
export const ACCORDION_WIDTH_LARGE = '900px';
export const ACCORDION_WIDTH_SMALL = '480px';

export const BILLING_PERIODS_TOP_LEVEL_ID = 'billing-periods';

export const DATE_PLACEHOLDER = 'MM/DD/YYYY';

export const PAGE_BOTTOM_PADDING = '24px';

export const PAGE_LAYOUT = {
  bottomSpacing: PAGE_BOTTOM_PADDING,
  rightSpacing: '24px',
  topSpacing: PAGE_TOP_PADDING,
};

const defaultPageSize = 20;

export const DEFAULT_PAGINATION_CONFIG = {
  pageSize: defaultPageSize,
  pageSizeOptions: [defaultPageSize, 50, 100],
  paginationHeight: 60,
};

export const NUMBER_OF_TABLE_LOADING_ROWS = defaultPageSize;

export enum StatusCodes {
  CONFLICT = 409,
  NOT_FOUND = 404,
}
